import * as React from "react";

function Twitter2(props) {
  return (
    <svg
      width={24}
      height={20}
      viewBox="0 0 24 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M24 2.31532C23.1075 2.70794 22.1565 2.96818 21.165 3.09453C22.185 2.4838 22.9635 1.52407 23.3295 0.367287C22.3785 0.935902 21.3285 1.33754 20.2095 1.56168C19.3065 0.597441 18.0195 0.000244141 16.6155 0.000244141C13.8915 0.000244141 11.6985 2.21754 11.6985 4.93577C11.6985 5.32688 11.7315 5.70294 11.8125 6.06096C7.722 5.86089 4.1025 3.89481 1.671 0.8998C1.2465 1.6384 0.9975 2.4838 0.9975 3.39389C0.9975 5.10274 1.875 6.61754 3.183 7.49453C2.3925 7.47949 1.617 7.24934 0.96 6.88681C0.96 6.90185 0.96 6.92141 0.96 6.94096C0.96 9.33877 2.6655 11.3304 4.902 11.7892C4.5015 11.899 4.065 11.9517 3.612 11.9517C3.297 11.9517 2.979 11.9336 2.6805 11.8675C3.318 13.8215 5.127 15.2581 7.278 15.3047C5.604 16.618 3.4785 17.4092 1.1775 17.4092C0.774 17.4092 0.387 17.3911 0 17.3415C2.1795 18.751 4.7625 19.5558 7.548 19.5558C16.602 19.5558 21.552 12.0344 21.552 5.51491C21.552 5.29679 21.5445 5.08619 21.534 4.8771C22.5105 4.18212 23.331 3.31416 24 2.31532Z" fill="#8A8D8F"/>
    </svg>
  );
}

export default Twitter2;
